/**
 * Created by Simon Zhao on 09/13/2022.
 * Argument models of note deposit trigger filter dialog.
 * ------ maintenance history ------
 */

import { DiagramConditionModel } from '../../../../models/workflow-condition.model';

 export class NoteTriggerFilterDialogOptions {
    condition: string;
    filters: Array<DiagramConditionModel>;
    fields: Array<any>;
}

export class NoteTriggerFilterDialogResult {
    isConfirmed = false;
    conditionResult: string;
    filterResult: Array<DiagramConditionModel>;
}
